export const texts = {
    "aboutUs": {
        "ca": "Qualisoluciones es una empresa ...",
        "es": "Qualisoluciones es una empresa ...",
        "en": "Qualisoluciones is an enterprise ..."
    }
}